import styles from "@/styles/my-account/order.module.scss"
import DefaultLayout from "@/components/DefaultLayout"
import MyAccountLayout from "@/components/MyAccountLayout"
import { Button, Form, Image, Input, message, Spin } from "antd"
import { useState } from "react"
import GoodsComponentWithDiscountNew from "@/components/GoodsComponentWithDiscountNew"
import { useEffect } from "react"
import myAccountApi from "@/service/modules/myAccountApi"
import { useRouter } from "next/router"
import homeApi from "@/service/modules/homeApi"
import Link from "next/link"
import { formatCurrency } from "@/utils/utils"
import CustomPagination from "@/components/CustomPagination"
import { LeftOutlined, RightOutlined } from "@ant-design/icons"
import Head from "next/head"
let isFirst = true
let isClearForm = true
let isSearch = false
export default function Order() {
  const [form] = Form.useForm();
  const router = useRouter()
  const { asPath } = router

  const defaultPage = 1
  const defaultPerPage = 10
  const [page, setPage] = useState(defaultPage)
  const [perPage, setPerPage] = useState(defaultPerPage)
  const [total, setTotal] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(true)
  const [recommendList, setRecommendList] = useState([])
  const statusNameObj: any = {
    'all': 0,
    'pending': 2,
    'processing': 3,
    'sent': 4,
    'cancelled': 1,
    'on-hold': 5,
    'un-reviewed': 7,
    'reviewed': 6
  }
  const titleObj: any = {
    0: "Show All",
    2: "Pending",
    3: "Processing",
    4: "Sent",
    1: "Cancelled",
    5: "On Hold",
    7: "Awaiting Reviewed",
    6: "Reviewed",
  }

  const orderStatusName = Array.isArray(router.query.orderStatusName) 
        ? router.query.orderStatusName[0] 
        : router.query.orderStatusName || 'all'
  const id = Number(statusNameObj[orderStatusName]) || 0

  useEffect(() => {
    if (router.isReady) {
      if (isClearForm) {
        form.resetFields()
      }
      setPage(defaultPage)
      setPerPage(defaultPerPage)
      getList(defaultPage, defaultPerPage)
    }
  }, [id, router.isReady])

  useEffect(() => {
    if (isFirst) {
      isFirst = false
      return
    }
    getList()
  }, [perPage, page])

  const getList = async (resetPage = page, resetPerPage = perPage) => {
    setLoading(true)
    try {
      const params = {
        page: resetPage,
        perPage: resetPerPage,
        status: id ? id : 0,
        search: form.getFieldValue("search"),
      }
      const res = await myAccountApi.getOrderList(params)
      const { list: { items, total } } = res.data

      setList(items)
      setTotal(total)
      setLoading(false)
      if (!items.length && isSearch) {
        message.warning("The order was not found")
      }
      isSearch = false
      isClearForm = true
    } catch (error: any) {
      setList([])
      setTotal(0)
      setLoading(false)
      console.log(error)
    }
  }

  useEffect(() => {
    getRecommendList()
  }, [])

  // 获取recommend
  const getRecommendList = async () => {
    try {
      const dataObj = { perPage: 25 }
      const res = await homeApi.getHomeRecommended(dataObj)
      const { pageList: { items } } = res.data
      setRecommendList(items)

    } catch (error: any) {
      console.log(error)
    }
  }

  const pageChange = (page: number, perPage: number) => {
    setPage(page)
    setPerPage(perPage)
  }


  const onSearch = (formVal: any) => {
    // const { search } = formVal
    // if (!search) {
    //   message.warning("Please fill in the search content")
    //   return
    // }
    if (asPath == '/my-account/order/all' || asPath == '/my-account/order') {
      getList(defaultPage, defaultPerPage)
    } else {
      isClearForm = false
      router.push(`/my-account/order/all`)
    }
    isSearch = true
  }

  const refreshList = () => {
    form.resetFields()
    getList(defaultPage, defaultPerPage)
  }

  return (
    <>
      <Head>
        <title>
          Online Shopping Australia - Beauty & Health, Computers, Toys, - Deals
          & Discounts | CrazySales
        </title>
        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        ></meta>
        <meta
          name="description"
          content="CrazySales.com.au - Australia's #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping Australia store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we've got it all, with free shipping on selected items!"
        ></meta>
      </Head>
      <DefaultLayout>
        <MyAccountLayout refreshList={refreshList}>
          <div className={styles['order']}>
            <div className={styles['order-head']}>
              <div className={styles['order-head-title']}>
                Order History - {titleObj[id]}
              </div>
              <div className={styles['order-head-search']}>
                <Form
                  name="search-form"
                  form={form}
                  onFinish={onSearch}
                >
                  <Form.Item name="search" style={{ marginBottom: 0 }}>
                    <div className={styles['search-box']}>
                      <Input
                        className={styles['order-head-search-input']}
                        placeholder="Enter product title or order number to search"
                      />
                      <Button className={styles['order-head-search-btn']} htmlType="submit">Search</Button>
                    </div>
                  </Form.Item>
                </Form>
              </div>
            </div>

            <Spin spinning={loading} style={{ minHeight: 200 }}>
              {
                list.length > 0
                  ?
                  <>
                    <div className={styles['pagination']}>
                      {
                        page > 1
                        &&
                        <LeftOutlined className={styles['allow-icon']} onClick={() => { pageChange(page - 1, perPage) }} disabled={loading} />
                      }
                      {
                        page < Math.ceil(total / perPage)
                        &&
                        <RightOutlined className={styles['allow-icon']} onClick={() => { pageChange(page + 1, perPage) }} disabled={loading} />
                      }
                    </div>

                    <OrderTable orders={list} type="list" />

                    <div className={styles['pagination']}>
                      <CustomPagination
                        pages={page}
                        pageSize={perPage}
                        total={total}
                        onChange={pageChange}
                        showQuickJumper={true}
                        hideOnSinglePage={true}
                        showSizeChanger={false}
                      />
                    </div>
                  </>
                  :
                  <>
                    {
                      !loading
                      &&
                      <div style={{ display: 'flex', justifyContent: 'center', marginTop: 56 }}>
                        <Button type="primary" href="/" >Continue Shopping</Button>
                      </div>
                    }
                  </>
              }
            </Spin>
          </div>
        </MyAccountLayout>
        <div className={styles['recommend-list']}>
          <div className={styles['recommend-list-title']}>Recommend For You</div>
          <div className={styles['recommend-list-content']}>
            {
              recommendList.map((item: any) => (
                <div className={styles['recommend-list-content-item']} key={item.productID}>
                  <GoodsComponentWithDiscountNew {...item} productName={item.name} imgUrl={item.filename} />
                </div>
              ))
            }
          </div>
        </div>
        <div style={{ height: '32px' }}></div>
      </DefaultLayout>
    </>
  )
}

const OrderTable = ({ orders }: any) => {
  return (
    <div className={styles['order-table']}>
      <div className={styles['order-table-head']}>
        <TableHeadItem title="Products" className={styles['products-column']} />
        <TableHeadItem title="Quantity" className={styles['quantity-column']} />
        <TableHeadItem title="Unit Price" className={styles['unit-price-column']} />
        <TableHeadItem title="Postage" className={styles['postage-column']} />
        <TableHeadItem title="Subtotal" className={styles['actual-paid-column']} />
        <TableHeadItem title="Discount" className={styles['discount-column']} />
        <TableHeadItem title="Logistics Query" className={styles['logistics-query-column']} />
        <TableHeadItem title="Status" className={styles['status-column']} />
        <TableHeadItem title="Tax Invoice" className={styles['tax-invoice-column']} />
      </div>

      <div className={styles['order-table-body']}>
        {orders.map((order: any, index: number) => (
          <OrderTableRow key={index} order={order} />
        ))}
      </div>
    </div>
  );
};

const TableHeadItem = ({ title, className }: { title: string, className: any }) => (
  <div className={`${styles['order-table-head-item']} ${className}`}>{title}</div>
);

const OrderTableRow = ({ order }: any) => (
  <div className={styles['order-table-body-item']}>
    <div className={styles['order-table-body-item-info']}>
      <div className={styles['order-table-body-item-info-time']}>
        Time: <span>{order.orderTime}</span>
      </div>
      <div className={styles['order-table-body-item-info-number']}>
        Order ID: <Link href={`/my-account/order-details/${order.orderID}`} legacyBehavior>
          <a rel="noopener noreferrer" target={'_blank'} style={{ color: '#319eff', fontWeight: 'bold' }}>
            {order.orderID}
          </a>
        </Link>
      </div>
    </div>
    {
      order.items.map((product: any, index: number) => (
        <ProductRow key={product.productID} index={index} product={product} statusName={order.statusName} statusID={order.statusID} orderId={order.orderID} orderDiscount={order.orderDiscount} returnCaseShow={order.returnCaseShow} />
      ))
    }
  </div >
);

const ProductRow = ({ product, statusName, statusID, orderId, index, orderDiscount, returnCaseShow }: any) => {
  const router = useRouter()
  const { id } = router.query;
  return (
    <div className={styles['order-table-body-item-product-tr']}>
      <div className={`${styles['order-table-body-item-product-td']} ${styles['products-column']}`}>
        <div className={styles['product-info']}>
          <Link href={product.url || "/"} legacyBehavior>
            <a className={styles['product-info-image']} rel="noopener noreferrer" target={'_blank'}>
              <Image
                style={{ width: '80px', height: '80px', objectFit: 'contain' }}
                src={product.defaultThumbnailUrl || product.defaultFullUrl}
                preview={false}
              />
            </a>
          </Link>
          <div className={styles['productDesc']}>
            <Link href={product.url || "/"} legacyBehavior>
              <a className={styles['product-info-name']} rel="noopener noreferrer" target={'_blank'}>
                {product.name}
              </a>
            </Link>
            <div className={styles['product-info-pid']}>PID: {product.productID}</div>
          </div>
        </div>
      </div>
      <div className={`${styles['order-table-body-item-product-td']} ${styles['quantity-column']}`}>
        {product.quantity}
      </div>
      <div className={`${styles['order-table-body-item-product-td']} ${styles['unit-price-column']}`}>
        {formatCurrency(product.price)}
      </div>
      <div className={`${styles['order-table-body-item-product-td']} ${styles['postage-column']}`}>
        {formatCurrency(product.postage)}
      </div>
      <div className={`${styles['order-table-body-item-product-td']} ${styles['actual-paid-column']}`}>
        <strong>{formatCurrency(product.subtotal)}</strong>
      </div>
      <div className={`${styles['order-table-body-item-product-td']} ${styles['discount-column']}`}>
        {
          index === 0 && !!orderDiscount
          &&
          <>
            {formatCurrency(orderDiscount)}
          </>
        }
      </div>
      <div className={`${styles['order-table-body-item-product-td']} ${styles['logistics-query-column']}`}>
        <div>
          {
            product.trackSiteUrls && product.trackSiteUrls.length
              ?
              product.trackSiteUrls.map((item: any) => (
                <div key={item.trackingNumber} className={styles['logistics-trackingNumber']}>
                  <div className={styles['track-number']}> {item.trackingNumber}</div>
                  {
                    !!(item.inSiteUrl || item.outSiteUrl)
                    &&
                  <Link
                    href={item.inSiteUrl || item.outSiteUrl || '/'}
                    legacyBehavior
                  >
                    <a rel="noopener noreferrer" target={'_blank'} className={styles['track-order']}>
                      Track Order
                    </a>
                  </Link>
                  }
                </div>
              ))
              :
              <span>{product.trackingNumber}</span>
          }
        </div>
      </div>
      <div className={`${styles['order-table-body-item-product-td']} ${styles['status-column']}`}>
        {
          (id == '6' || id == '7')
            ?
            product.isReviewed
              ?
              'Reviewed'
              :
              <Link
                  href={`/review/write-review/${product.productID}/${orderId}`}
                legacyBehavior
                >
                <a rel="noopener noreferrer" target="_blank" style={{ color: '#D70B17', fontSize: '12px' }}>
                  Write A Review
                </a>
              </Link>
            :
            statusName
        }
      </div>
      <div className={`${styles['order-table-body-item-product-td']} ${styles['tax-invoice-column']}`}>
        <div className={styles['product-config']}>
          {
            index === 0
            &&
            <>
              {
                statusID == 2
                  ?
                  <Button type="primary" href={`/my-account/order-details/${orderId}`} className={styles['click-to-pay']}>Click to PAY</Button>
                  :
                  <Button type="link" href={`/my-account/order-details/${orderId}`} className={styles['product-config-btn']}>View detail</Button>
              }
              <Button type="link" onClick={() => { window.open(`/my-account/orderinvoice/${orderId}`, 'Print Invoice', 'location=0, menubar=0, status=0, toolbar=0') }} className={styles['product-config-btn']}>Print invoice</Button>
              {
                returnCaseShow
                && <Button type="link" href={`/my-account/return-tracking?orderId=${orderId}`} className={styles['product-config-btn']} target="_blank">Return Back</Button>
              }
            </>
          }
        </div>
      </div>
    </div>
  );
}